import { FlatItem } from 'src/types/elements.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'master-data/national-legacies';

export const getNationalsDropdown = async () => {
  return await http.get<FlatItem[]>(`${controller}/dropdown`);
};
